import { createSlice } from '@reduxjs/toolkit';

const initialState = {};

const channelSlice = createSlice({
    name: 'channel',
    initialState,
    reducers: {
        setChannel: (state, { payload }) => {
            return payload;
        },
    }
});

export const {
    setChannel,
} = channelSlice.actions;

export default channelSlice.reducer;